var $ = jQuery;
$(function() {
    if($('.alert_banner').length) {
        var alerts = $('.alerts > li');
        var alert_count = alerts.length;
        $('*[data-alert-index="1"]').fadeIn();

        if(alert_count > 1) {
            var index = 2;
            var seconds = 5;

            setInterval(function() {
                if(index > (alert_count)) {
                    index = 1;
                }

                // Hide all alerts to display next one
                alerts.hide();

                $('*[data-alert-index="' + index + '"]').fadeIn();

                index = index+1;
            }, seconds*1000);
        }
    }
});